import { actions } from "./Reducer";
/**
 * Actions that fire saga watchers
 */

// singular

export const getSupplierAction = (id) => ({
  type : actions.GET_SUPPLIER,
  payload : id
})

export const createSupplierAction = (formData,noRedirect) => ({
  type: actions.CREATE_SUPPLIER,
  payload: formData,
  noRedirect
});

export const updateSupplierAction = (id, formData) => ({
  type: actions.UPDATE_SUPPLIER,
  payload: {
    id,
    formData,
  },
}); 

export const updateSupplierLimitAction = (body) => ({
  type: actions.UPDATE_SUPPLIER_LIMIT,
  payload: body
})

export const deleteSupplierAction = (id) => ({
  type: actions.DELETE_SUPPLIER,
  payload: id,
});

// Plural
export const getSuppliersAction = (body) => ({
  type: actions.GET_SUPPLIERS,
  payload: body,
});


export const addFollower = (supplierId, userId) => ({
  type: actions.ADD_FOLLOWER_ARTISAN,
  payload: {
    supplierId,
    userId
  }
})

export const removeFollower = (supplierId, userId) => ({
  type: actions.REMOVE_FOLLOWER_ARTISAN,
  payload: {
    supplierId,
    userId
  }
})

export const getFollowers = (supplierId) => ({
  type: actions.GET_FOLLOWERS,
  payload: supplierId
})

export const addEditorReviewSupplier = (supplierId,formData) => ({
  type: actions.ADD_EDITOR_REVIEW_SUPPLIER,
  payload: {
    supplierId,
    formData
  }
})

/**
 * Actions that are fired by redux-saga watchers
 */

// singular
export const getSupplierSuccessAction = (supplier) => ({
  type : actions.GET_SUPPLIER_SUCCESS,
  payload : supplier
})

export const createSupplierSuccessAction = (supplier) => ({
  type: actions.CREATE_SUPPLIER_SUCCESS,
  payload: supplier,
});

export const updateSupplierSuccessAction = (supplier) => ({
  type: actions.UPDATE_SUPPLIER_SUCCESS,
  payload: supplier,
});

export const deleteSupplierSuccessAction = (supplierId) => ({
  type: actions.DELETE_SUPPLIER_SUCCESS,
  payload: supplierId,
});

// Plural
export const getSuppliersSuccessAction = (suppliers) => ({
  type: actions.GET_SUPPLIERS_SUCCESS,
  payload: suppliers,
});

/**
 * Misc
 */
export const setSuppliersIsLoadingAction = (isLoading) => ({
  type: actions.SET_SUPPLIERS_IS_LOADING,
  payload: isLoading,
});

export const setSuppliersCountAction = (count) => ({
  type: actions.SET_SUPPLIERS_COUNT,
  payload: count,
});

export const setSearchValueAction = (value) => ({
  type: actions.SET_SUPPLIERS_SEARCH_VALUE,
  payload: value,
});
